import { contractRepository } from './repository';
import ContractServiceImpl from './service/ContractServiceImpl';

const contractService = new ContractServiceImpl(contractRepository);

export { contractService };
